<template>
  <UserCommonLayout class-name="dark" :content-detail-title="contestDetail.title">
    <template #content>
      <LazyContestDetail
        v-if="isLoading"
        :contest-detail="contestDetail"
        :contest-id="contestId"
        :contest-navigator-type="contestNavigatorType"/>
    </template>
  </UserCommonLayout>
</template>

<script setup lang="ts">
import {computed, onMounted, ref, useRoute, useRouter, watch} from "#imports";
import {LazyContestDetail, UserCommonLayout, LearningConfirmPopupType} from '#components';
import {useNuxtApp} from "#app";
import {useContestService} from "~/composables/service/useContestService";
import {ContestListModel} from "~~/package/mapper/contest/model/ContestListModel";
import {ContestNavigatorType} from "~~/package/mapper/contest/model/ContestNavigatorType";
import {useLoadingStore} from "~/store/loading/loadingStore";
import {ContestStatusType} from "~~/package/mapper/contest/model/ContestStatusType";
import {useI18n} from "vue-i18n";
import DialogType from "~/components/Common/Dialog/model/DialogType";
import {useDialogStore} from "~/store/dialog/dialogStore";

const route = useRoute();
const router = useRouter();
const { t } = useI18n();
const {$i18n} = useNuxtApp();
const lang = computed(() =>
    $i18n.locale.value.toUpperCase()
);
let contestId: number = 0;
const contestNavigatorType = ref(ContestNavigatorType.OVER_VIEW);
const contestDetail = ref(new ContestListModel());
const isLoading = ref(false);
const loadingStore = useLoadingStore();
const dialogStore = useDialogStore();

onMounted(() => {
  checkRecordingIssue();

  contestId = parseInt(route.params.contestId as string);
  contestNavigatorType.value = route.query.type === undefined ? ContestNavigatorType.OVER_VIEW : ContestNavigatorType.LEADER_BOARD;
  initData();
})

const initData = () => {
  Promise.all([useContestService().getContestDetail(contestId, lang.value)]).then(resolve => {
    contestDetail.value = resolve[0];

    loadingStore.closeLoading();
    isLoading.value = !loadingStore.show;

    if(contestDetail.value.status !== ContestStatusType.EXPOSED){
      router.push({ path: "/" })
    }
  })
}

const getContestDetail = (contestId: number, lang: string) => {
  useContestService().getContestDetail(contestId, lang).then(detail => {
    contestDetail.value = detail;
  })
}

watch($i18n.locale, () => {
  getContestDetail(contestId, lang.value);
});

const checkRecordingIssue = () => {
  const isRecordingIssue = sessionStorage.getItem('isRecordingIssue');
  if (isRecordingIssue && isRecordingIssue === 'true') {
    openConnectFailPopup();
    sessionStorage.removeItem('isRecordingIssue');
  }
}

const openConnectFailPopup = () => {
  dialogStore.open({
    type: DialogType.LearningConfirmPopup,
    props: {
      type: LearningConfirmPopupType.CONNECT_FAIL
    },
    confirm: {
      event: () => {}
    },
  })
}
</script>
